import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { Link } from "gatsby";

import GatsbyImageWithSVGSupport from "./GatsbyImageWithSVGSupport";
import BusinessInfoModalForm from "./BusinessInfoModalForm";

import { openModal, selectModalId } from "../redux/slices/businessModalSlice";

import "../styles/components/Webinar.scss";

const Webinar = ({ id, title, media, ctaLink, isFreeToDownload }) => {
    const dispatch = useDispatch();
    const modalId = useSelector(selectModalId);

    let btnProps;
    if (!isFreeToDownload) {
        btnProps = {
            onClick: () =>
                dispatch(
                    openModal({
                        modalId: id,
                        link: ctaLink,
                        source: "webinar",
                    })
                ),
        };
    } else if (ctaLink.startsWith("/")) {
        btnProps = {
            as: Link,
            to: ctaLink,
        };
    } else {
        btnProps = {
            as: "a",
            href: ctaLink,
        };
    }

    return (
        <div className="webinar p-4">
            <GatsbyImageWithSVGSupport
                image={media}
                className="webinar-image mb-3 ratio ratio-16x9"
            />
            <h5 className="mb-3">{title}</h5>
            <Button variant="link" className="mt-auto p-0" {...btnProps}>
                Watch Now &rarr;
            </Button>
            {id === modalId && <BusinessInfoModalForm />}
        </div>
    );
};

Webinar.propTypes = {
    title: PropTypes.string.isRequired,
    media: PropTypes.shape({
        title: PropTypes.string,
        description: PropTypes.string,
        gatsbyImageData: PropTypes.object,
        file: PropTypes.shape({
            contentType: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
        }),
    }),
    ctaLink: PropTypes.string.isRequired,
    isFreeToDownload: PropTypes.bool,
};

export default Webinar;
